import axios from "axios";
import { getDocumentAsync } from "expo-document-picker";
import React, { useState } from "react";
import {
  Text,
  View,
  StyleSheet,
  TextInput,
  Pressable,
  ActivityIndicator,
} from "react-native";
import { useDispatch } from "react-redux";
import { serviceResponse } from "../../../services/common";
import { createResource } from "../../../services/Resource";
import StorageService from "../../../services/storage";
import { colors, globalStyles } from "../../Shared";
import SettingsHeader from "../Header";
import PositionSelector from "../position/Selector";

const storageService = new StorageService();

interface Props {
  onBack: () => void;
}

export default function CreateResource({ onBack }: Props) {
  const dispatch = useDispatch();
  const [name, setName] = useState("");
  const [positionName, setPositionName] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const [localUri, setLocalUri] = useState("");
  const [fileName, setFileName] = useState("");

  const [showPositionSelector, setShowPositionSelector] = useState(false);

  const onSelectDocument = async () => {
    try {
      const result = await getDocumentAsync({});
      if (result.type === "cancel") {
        return;
      }

      const { name, uri } = result;
      setLocalUri(uri);
      setFileName(name);
      const ext = name.split(".").reverse()[0];

      // console.log(name, uri);
    } catch (error) {
      console.log(error);
    }
  };

  const uploadFile = async () => {
    const [name, ext] = fileName.split(".");
    const upload = await storageService.uploadFile(localUri, ext);
    if (
      upload === serviceResponse.emptyFields ||
      upload === serviceResponse.systemError
    ) {
      console.log(upload);

      return alert("Something went wrong, please try it again");
    }

    return upload;
  };

  const next = async () => {
    try {
      if (!name || isLoading) {
        return;
      }

      setIsLoading(true);

      const fileUri = await uploadFile();

      if (!fileUri) {
        return alert(
          "Something went wrong, the document could not be uploaded, please try it again"
        );
      }

      if (!name || !positionName) {
        return alert("Please complete the all fields");
      }

      const create = await createResource(name, positionName, fileName, fileUri);

      if (
        create === serviceResponse.systemError ||
        create === serviceResponse.emptyFields
      ) {
        return alert("Something went wrong, please try it again");
      }
      onBack();
    } catch (error) {
      console.log(error);
      return alert("Something went wrong, please try it again");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <View style={styles.container}>
      <SettingsHeader title="Create resource" onBack={onBack} />

      <View style={{ flex: 1, justifyContent: "center", padding: 80 }}>
        <TextInput
          style={[
            globalStyles.transparentBorderInput,
            { width: "100%", paddingLeft: 5 },
          ]}
          placeholder="Name"
          placeholderTextColor="#d8d8d8"
          onChangeText={setName}
          blurOnSubmit={false}
          value={name}
          onSubmitEditing={next}
          keyboardType="default"
        />

        <View style={styles.buttonContainer}>
          <Pressable
            style={styles.button}
            onPress={() => setShowPositionSelector(true)}
          >
            Position
          </Pressable>
          <Text style={{ textTransform: "capitalize" }}>{positionName}</Text>
        </View>

        <View style={styles.buttonContainer}>
          <Pressable style={styles.button} onPress={onSelectDocument}>
            Select file
          </Pressable>
          <Text>{fileName}</Text>
        </View>
      </View>

      <View style={styles.footerContainer}>
        <Pressable style={styles.footerButton} onPress={next}>
          {isLoading && <ActivityIndicator />}
          {!isLoading && (
            <Text style={{ color: colors.text.white }}>Continuar</Text>
          )}
        </Pressable>
      </View>

      <PositionSelector
        isVisible={showPositionSelector}
        onClose={() => setShowPositionSelector(false)}
        onSelect={({ name }) => setPositionName(name)}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  footerContainer: {
    padding: 10,
  },
  footerButton: {
    marginHorizontal: "auto",
    height: 50,
    borderRadius: 5,
    backgroundColor: colors.bg.primary,
    width: "35%",
    justifyContent: "center",
    alignItems: "center",
  },
  buttonContainer: {
    flexDirection: "row",
    alignItems: "center",
    marginTop: 8,
  },
  button: {
    backgroundColor: colors.bg.medium,
    borderRadius: 5,
    width: 120,
    height: 45,
    justifyContent: "center",
    alignItems: "center",
    marginRight: 10,
  },
});
